import { useCallback } from 'react'

import client from 'api'

export const useSettingsUpdate = () => {
    const updateSetting = useCallback(async (settingName: string, val: any) => {
        try {
            const res = await client.post('/api/ixweb/usr-settings/', { [settingName]: val })
            return res.data
        } catch(err) {
            console.error('Failed to update user settings')
        }
    }, [])

    return updateSetting
}
